"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _ImageEditor = _interopRequireDefault(require("FileManagerCore/components/ImageEditor"));

var _UIPanel = _interopRequireDefault(require("UIComponents/panel/UIPanel"));

var _UIPanelHeader = _interopRequireDefault(require("UIComponents/panel/UIPanelHeader"));

var _UIPanelFooter = _interopRequireDefault(require("UIComponents/panel/UIPanelFooter"));

var _UIPanelSection = _interopRequireDefault(require("UIComponents/panel/UIPanelSection"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIModalPanel = _interopRequireDefault(require("UIComponents/dialog/UIModalPanel"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _scrollbarSize = _interopRequireDefault(require("FileManagerCore/utils/scrollbarSize"));

var _Files = require("FileManagerLib/actions/Files");

var _DragAndDropOverlay = _interopRequireDefault(require("FileManagerCore/components/DragAndDropOverlay"));

var _Constants = require("FileManagerLib/Constants");

var Actions = _interopRequireWildcard(require("FileManagerLib/actions/Actions"));

var _ActivePanel = _interopRequireDefault(require("FileManagerLib/components/browser/ActivePanel"));

var _Footer = _interopRequireDefault(require("FileManagerLib/components/browser/Footer"));

var _UserSettings = require("FileManagerCore/actions/UserSettings");

var _Files2 = require("FileManagerCore/actions/Files");

var _Limits = require("FileManagerCore/actions/Limits");

var _FileManagerPortalData = require("FileManagerCore/actions/FileManagerPortalData");

var _IdentityRepository = require("FileManagerCore/actions/IdentityRepository");

var _Auth = require("FileManagerCore/selectors/Auth");

var _EditAndCreateImage = require("FileManagerCore/selectors/EditAndCreateImage");

var _Limits2 = require("FileManagerCore/selectors/Limits");

var _Panel = require("FileManagerLib/selectors/Panel");

var _fileUploads = require("FileManagerLib/utils/fileUploads");

var _Constants2 = require("FileManagerCore/Constants");

var _FileManagerPortalData2 = require("FileManagerCore/selectors/FileManagerPortalData");

var _VidyardTermsOfServiceModal = _interopRequireDefault(require("FileManagerCore/components/VidyardTermsOfServiceModal"));

var _IdentityRepository2 = require("FileManagerCore/selectors/IdentityRepository");

var _hubLVideo = require("FileManagerCore/utils/hubLVideo");

var _ImageOptimizationSettings = require("FileManagerLib/selectors/ImageOptimizationSettings");

var ImageOptimizationSettings = _interopRequireWildcard(require("FileManagerLib/enums/ImageOptimizationSettings"));

var _getIsFileOptimizableImage = _interopRequireDefault(require("FileManagerLib/utils/getIsFileOptimizableImage"));

var _getOptimizedImage = _interopRequireDefault(require("FileManagerLib/utils/getOptimizedImage"));

var getDrawerType = function getDrawerType(type) {
  return _Constants.DrawerTypes[type] ? type : _Constants.DrawerTypes.FILE;
};

var fileTarget = {
  drop: function drop(props, monitor) {
    var onDropFiles = props.onDropFiles,
        selectedFolder = props.selectedFolder,
        type = props.type;

    if (monitor.didDrop()) {
      return;
    }

    var files = monitor.getItem().files;
    var options = {
      type: getDrawerType(type)
    };

    if (selectedFolder) {
      options.folderId = selectedFolder.get('id');
    }

    onDropFiles(files, options);
  }
};

var Drawer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Drawer, _Component);

  function Drawer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Drawer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Drawer).call(this, props));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isVidyardModalDismissed: false
    };
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          fetchInitialUserSettings = _this$props.fetchInitialUserSettings,
          type = _this$props.type,
          user = _this$props.user,
          hasVideoIntegrationScope = _this$props.hasVideoIntegrationScope,
          dispatchGetFetchInferredUserRole = _this$props.dispatchGetFetchInferredUserRole,
          dispatchFetchFileManagerPortalData = _this$props.dispatchFetchFileManagerPortalData,
          dispatchGetLimits = _this$props.dispatchGetLimits;

      if (user && user.user_id && type === _Constants.DrawerTypes.IMAGE) {
        fetchInitialUserSettings(user.user_id);
      }

      if (type === _Constants.DrawerTypes.HUBL_VIDEO && hasVideoIntegrationScope) {
        dispatchFetchFileManagerPortalData();
        dispatchGetFetchInferredUserRole();
        dispatchGetLimits();
      }

      this.fireGlobalOpenEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.fireGlobalCloseEvent();
    } // The drawer fires global events on open and close in order to help apps work around a Chrome bug
    // that prevents drag and drop events to the file manager drawer if it is on top of an iframe.
    // More info in https://git.hubteam.com/HubSpot/FileManagerUI/pull/1272

  }, {
    key: "fireGlobalOpenEvent",
    value: function fireGlobalOpenEvent() {
      var event = new CustomEvent('FileManagerLib:Drawer:open');
      document.dispatchEvent(event);
    }
  }, {
    key: "fireGlobalCloseEvent",
    value: function fireGlobalCloseEvent() {
      var event = new CustomEvent('FileManagerLib:Drawer:close');
      document.dispatchEvent(event);
    }
  }, {
    key: "getShouldRenderVideoIntegrationEmptyContent",
    value: function getShouldRenderVideoIntegrationEmptyContent() {
      var _this$props2 = this.props,
          vidyardTosStatus = _this$props2.vidyardTosStatus,
          fetchFileManagerPortalDataRequestStatus = _this$props2.fetchFileManagerPortalDataRequestStatus,
          hasVideoIntegrationScope = _this$props2.hasVideoIntegrationScope,
          type = _this$props2.type;
      return getDrawerType(type) === _Constants.DrawerTypes.HUBL_VIDEO && hasVideoIntegrationScope && fetchFileManagerPortalDataRequestStatus === _Constants2.RequestStatus.SUCCEEDED && (vidyardTosStatus === _Constants2.VidyardTosStatus.NOT_ASKED || vidyardTosStatus === _Constants2.VidyardTosStatus.DISABLED);
    }
  }, {
    key: "getShouldVidyardTosModalRender",
    value: function getShouldVidyardTosModalRender() {
      var isVidyardModalDismissed = this.state.isVidyardModalDismissed;
      return !isVidyardModalDismissed && this.getShouldRenderVideoIntegrationEmptyContent();
    }
  }, {
    key: "getAreUploadsAllowed",
    value: function getAreUploadsAllowed() {
      var _this$props3 = this.props,
          type = _this$props3.type,
          hasUserExceededVideoLimit = _this$props3.hasUserExceededVideoLimit;
      return (0, _fileUploads.getShouldAllowUploads)({
        type: type,
        hasUserExceededVideoLimit: hasUserExceededVideoLimit
      });
    }
  }, {
    key: "dismissVidyardModal",
    value: function dismissVidyardModal() {
      this.setState({
        isVidyardModalDismissed: true
      });
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var type = this.props.type;

      switch (getDrawerType(type)) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.insertImage');

        case _Constants.DrawerTypes.VIDEO:
          return _I18n.default.text('FileManagerLib.insertVideo');

        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.insertHubLVideo');

        case _Constants.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.insertDocument');

        case _Constants.DrawerTypes.FILE:
        default:
          return _I18n.default.text('FileManagerLib.insertFile');
      }
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      // React 16 portals bubble events up
      event.stopPropagation();
      this.props.onClose(event);
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(file) {
      var _this$props4 = this.props,
          onSelect = _this$props4.onSelect,
          trackInteraction = _this$props4.trackInteraction,
          type = _this$props4.type,
          imageOptimizationSetting = _this$props4.imageOptimizationSetting;

      if (imageOptimizationSetting !== ImageOptimizationSettings.MEDIUM && (0, _getIsFileOptimizableImage.default)(file)) {
        onSelect((0, _getOptimizedImage.default)(file, imageOptimizationSetting));
      } else {
        onSelect(file);
      }

      if (type === _Constants.DrawerTypes.HUBL_VIDEO) {
        trackInteraction('Manage Files', 'insert-hubl-video');
      } else {
        trackInteraction('Manage Files', 'insert');
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement("h4", null, this.getTitle());
    }
  }, {
    key: "renderVidyardTosModal",
    value: function renderVidyardTosModal() {
      var _this2 = this;

      var _this$props5 = this.props,
          isFileManagerPortalDataUpdatePending = _this$props5.isFileManagerPortalDataUpdatePending,
          inferredUserRole = _this$props5.inferredUserRole,
          dispatchUpdateVidyardTosStatus = _this$props5.dispatchUpdateVidyardTosStatus,
          trackInteraction = _this$props5.trackInteraction;
      return _react.default.createElement(_VidyardTermsOfServiceModal.default, {
        inferredUserRole: inferredUserRole,
        updateVidyardTosStatus: dispatchUpdateVidyardTosStatus,
        isLoading: isFileManagerPortalDataUpdatePending,
        onClose: function onClose() {
          return _this2.dismissVidyardModal();
        },
        trackInteraction: (0, _hubLVideo.wrapTrackHubLVideoInteraction)(trackInteraction)
      });
    }
  }, {
    key: "renderEmptyVideoIntegrationContent",
    value: function renderEmptyVideoIntegrationContent(_ref) {
      var type = _ref.type,
          onClose = _ref.onClose,
          _ref$headerClassName = _ref.headerClassName,
          headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName;
      return _react.default.createElement("div", null, _react.default.createElement(_UIPanelHeader.default, {
        className: headerClassName
      }, this.renderHeader(), _react.default.createElement(_UICloseButton.default, {
        className: "drawer__close-button",
        onClick: onClose
      })), _react.default.createElement(_UIPanelSection.default, {
        className: "drawer__body"
      }, _react.default.createElement(_ActivePanel.default, {
        type: getDrawerType(type),
        onInsert: this.handleInsert,
        isPanelInactive: true
      })));
    }
  }, {
    key: "renderPanelContent",
    value: function renderPanelContent(_ref2) {
      var connectDropTarget = _ref2.connectDropTarget,
          onClose = _ref2.onClose,
          type = _ref2.type,
          isOver = _ref2.isOver,
          dropdownClassName = _ref2.dropdownClassName;

      var panelContent = _react.default.createElement("div", {
        className: "drawer__drop-target"
      }, _react.default.createElement(_DragAndDropOverlay.default, {
        isOver: isOver
      }), _react.default.createElement(_UIPanelHeader.default, null, this.renderHeader(), _react.default.createElement(_UICloseButton.default, {
        className: "drawer__close-button",
        onClick: onClose
      })), _react.default.createElement(_UIPanelSection.default, {
        className: "drawer__body"
      }, _react.default.createElement(_ActivePanel.default, {
        onInsert: this.handleInsert,
        type: getDrawerType(type)
      })), _react.default.createElement(_UIPanelFooter.default, null, _react.default.createElement(_Footer.default, {
        type: getDrawerType(type),
        dropdownClassName: dropdownClassName
      })));

      if (!this.getAreUploadsAllowed()) {
        return panelContent;
      }

      return connectDropTarget(panelContent);
    }
  }, {
    key: "renderPanel",
    value: function renderPanel() {
      /* eslint-disable indent */
      var _this$props6 = this.props,
          className = _this$props6.className,
          connectDropTarget = _this$props6.connectDropTarget,
          type = _this$props6.type,
          isOver = _this$props6.isOver,
          googleDriveOrigin = _this$props6.googleDriveOrigin,
          dropdownClassName = _this$props6.dropdownClassName;
      return _react.default.createElement(_UIPanel.default, {
        className: (0, _classNames.default)('drawer', className),
        panelClassName: "drawer__container is-panel",
        align: "right",
        width: 462 + (0, _scrollbarSize.default)()
      }, this.getShouldRenderVideoIntegrationEmptyContent() ? this.renderEmptyVideoIntegrationContent({
        type: type,
        onClose: this.onClose
      }) : this.renderPanelContent({
        connectDropTarget: connectDropTarget,
        onClose: this.onClose,
        type: type,
        isOver: isOver,
        googleDriveOrigin: googleDriveOrigin,
        dropdownClassName: dropdownClassName
      }));
    }
  }, {
    key: "renderSideModalContent",
    value: function renderSideModalContent(_ref3) {
      var connectDropTarget = _ref3.connectDropTarget,
          onClose = _ref3.onClose,
          type = _ref3.type,
          isOver = _ref3.isOver,
          googleDriveOrigin = _ref3.googleDriveOrigin,
          dropdownClassName = _ref3.dropdownClassName;

      var sideModalContent = _react.default.createElement("div", {
        className: "drawer__drop-target"
      }, _react.default.createElement(_DragAndDropOverlay.default, {
        isOver: isOver
      }), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClose
      }), _react.default.createElement(_UIDialogHeader.default, null, this.renderHeader()), _react.default.createElement(_UIDialogBody.default, {
        className: "drawer__body"
      }, _react.default.createElement(_ActivePanel.default, {
        type: getDrawerType(type),
        onInsert: this.handleInsert
      })), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_Footer.default, {
        type: getDrawerType(type),
        googleDriveOrigin: googleDriveOrigin,
        dropdownClassName: dropdownClassName
      })));

      if (!this.getAreUploadsAllowed()) {
        return sideModalContent;
      }

      return connectDropTarget(sideModalContent);
    }
  }, {
    key: "renderSideModal",
    value: function renderSideModal() {
      var _this$props7 = this.props,
          className = _this$props7.className,
          onCloseComplete = _this$props7.onCloseComplete,
          connectDropTarget = _this$props7.connectDropTarget,
          type = _this$props7.type,
          isOver = _this$props7.isOver,
          googleDriveOrigin = _this$props7.googleDriveOrigin,
          dropdownClassName = _this$props7.dropdownClassName;
      return _react.default.createElement(_UIModalPanel.default, {
        className: (0, _classNames.default)('drawer', 'fileManagerSideModal', className),
        width: 462 + (0, _scrollbarSize.default)(),
        onCloseComplete: onCloseComplete
      }, this.getShouldRenderVideoIntegrationEmptyContent() ? this.renderEmptyVideoIntegrationContent({
        type: type,
        onClose: this.onClose,
        headerClassName: 'm-top-0'
      }) : this.renderSideModalContent({
        connectDropTarget: connectDropTarget,
        onClose: this.onClose,
        type: type,
        isOver: isOver,
        googleDriveOrigin: googleDriveOrigin,
        dropdownClassName: dropdownClassName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          pickerType = _this$props8.pickerType,
          imgToEditSelected = _this$props8.imgToEditSelected,
          selectedImgFrom = _this$props8.selectedImgFrom,
          dispatchUploadEditedImage = _this$props8.dispatchUploadEditedImage,
          dispatchUploadResizedImage = _this$props8.dispatchUploadResizedImage,
          dispatchDeselectImageToEdit = _this$props8.dispatchDeselectImageToEdit;
      return _react.default.createElement("div", null, pickerType === _Constants.PickerTypes.SIDE_MODAL ? this.renderSideModal() : this.renderPanel(), this.getShouldVidyardTosModalRender() && this.renderVidyardTosModal(), imgToEditSelected && selectedImgFrom === _Constants2.ImageEditorLocations.DRAWER && _react.default.createElement(_ImageEditor.default, {
        onClose: dispatchDeselectImageToEdit,
        onCropSave: dispatchUploadEditedImage,
        onResizeSave: dispatchUploadResizedImage
      }));
    }
  }]);
  return Drawer;
}(_react.Component);

Drawer.propTypes = {
  className: _react.PropTypes.string,
  imgToEditSelected: _react.PropTypes.bool.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  onCloseComplete: _react.PropTypes.func,
  onSelect: _react.PropTypes.func.isRequired,
  trackInteraction: _react.PropTypes.func.isRequired,
  isOver: _react.PropTypes.bool.isRequired,
  type: _react.PropTypes.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  pickerType: _react.PropTypes.oneOf(Object.keys(_Constants.PickerTypes)).isRequired,
  connectDropTarget: _react.PropTypes.func.isRequired,
  fetchInitialUserSettings: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  hasVideoIntegrationScope: _react.PropTypes.bool.isRequired,
  dispatchUploadEditedImage: _react.PropTypes.func.isRequired,
  dispatchUploadResizedImage: _react.PropTypes.func.isRequired,
  dispatchFetchFileManagerPortalData: _react.PropTypes.func.isRequired,
  dispatchGetFetchInferredUserRole: _react.PropTypes.func.isRequired,
  vidyardTosStatus: _react.PropTypes.oneOf(Object.keys(_Constants2.VidyardTosStatus)).isRequired,
  fetchFileManagerPortalDataRequestStatus: _react.PropTypes.oneOf(Object.keys(_Constants2.RequestStatus)).isRequired,
  isFileManagerPortalDataUpdatePending: _react.PropTypes.bool.isRequired,
  dispatchUpdateVidyardTosStatus: _react.PropTypes.func.isRequired,
  inferredUserRole: _react.PropTypes.string.isRequired,
  dispatchGetLimits: _react.PropTypes.func.isRequired,
  dispatchDeselectImageToEdit: _react.PropTypes.func.isRequired,
  hasUserExceededVideoLimit: _react.PropTypes.bool.isRequired,
  googleDriveOrigin: _react.PropTypes.string,
  selectedImgFrom: _react.PropTypes.string.isRequired,
  imageOptimizationSetting: _react.PropTypes.oneOf(Object.values(ImageOptimizationSettings)).isRequired,

  /* eslint-disable react/no-unused-prop-types */
  onDropFiles: _react.PropTypes.func.isRequired,
  selectedFolder: _react.PropTypes.instanceOf(_immutable.default.Map),
  dropdownClassName: _react.PropTypes.string
};
var DrawerWithDropTarget = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, fileTarget, function (dragAndDropConnect, monitor) {
  return {
    connectDropTarget: dragAndDropConnect.dropTarget(),
    isOver: monitor.isOver()
  };
})(Drawer);
DrawerWithDropTarget.defaultProps = {
  type: _Constants.DrawerTypes.IMAGE,
  pickerType: _Constants.PickerTypes.PANEL
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    user: (0, _Auth.getUser)(state),
    hasVideoIntegrationScope: (0, _Auth.getHasVideoIntegrationScope)(state),
    vidyardTosStatus: (0, _FileManagerPortalData2.getVidyardTosStatus)(state),
    fetchFileManagerPortalDataRequestStatus: (0, _FileManagerPortalData2.getFileManagerPortalDataFetchRequestStatus)(state),
    isFileManagerPortalDataUpdatePending: (0, _FileManagerPortalData2.getFileManagerPortalDataUpdateRequestStatus)(state) === _Constants2.RequestStatus.PENDING,
    inferredUserRole: (0, _IdentityRepository2.getInferredUserRole)(state),
    hasUserExceededVideoLimit: (0, _Limits2.getHasUserExceededEmbeddableVideoLimit)(state),
    imgToEditSelected: (0, _EditAndCreateImage.getSelectedImageToEdit)(state),
    selectedImgFrom: (0, _EditAndCreateImage.getSelectedImageFrom)(state),
    imageOptimizationSetting: (0, _ImageOptimizationSettings.getImageOptimizationSetting)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackInteraction: function trackInteraction(name, action, meta) {
      dispatch(Actions.trackInteraction(name, action, meta));
    },
    onDropFiles: function onDropFiles(files, options) {
      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch(Actions.trackInteraction('Manage Files', 'drag-and-dropped-file'));
    },
    fetchInitialUserSettings: function fetchInitialUserSettings(userId) {
      dispatch((0, _UserSettings.fetchUserSettings)(userId));
    },
    dispatchFetchFileManagerPortalData: function dispatchFetchFileManagerPortalData() {
      dispatch((0, _FileManagerPortalData.fetchFileManagerPortalData)());
    },
    dispatchGetFetchInferredUserRole: function dispatchGetFetchInferredUserRole() {
      dispatch((0, _IdentityRepository.getFetchInferredUserRole)());
    },
    dispatchUpdateVidyardTosStatus: function dispatchUpdateVidyardTosStatus(status) {
      dispatch((0, _FileManagerPortalData.getUpdateVidyardTosStatus)(status));
    },
    dispatchGetLimits: function dispatchGetLimits() {
      dispatch((0, _Limits.fetchLimits)());
    },
    dispatchUploadEditedImage: function dispatchUploadEditedImage(file, fileName, fileFolderId) {
      return dispatch((0, _Files2.uploadEditedImage)(file, fileName, fileFolderId));
    },
    dispatchUploadResizedImage: function dispatchUploadResizedImage(fileId, newWidth) {
      return dispatch((0, _Files2.uploadResizedImage)(fileId, newWidth));
    },
    dispatchDeselectImageToEdit: function dispatchDeselectImageToEdit() {
      return dispatch((0, _Files2.getDeselectImageToEditAction)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DrawerWithDropTarget);

exports.default = _default;
module.exports = exports.default;